import { useMemo, useState } from "react";
import { Modal, } from 'react-bootstrap';
import { width, } from "../../helpers";
import { getLocation } from "../../helpers/general";
import { Button } from "reactstrap";
import "./styles.scss"
import { GoogleMap, useJsApiLoader, useLoadScript, Marker, InfoBox } from "@react-google-maps/api";

const _geo = getLocation();
const Index = (props) => {

    const [location, setLocation] = useState({ lat: _geo?.latitude || -16.94964469606446, lng: _geo?.longitude || -49.234033195811534 });

    function handleClose() {
        if (props.handleClose)
            props.handleClose();
    }

    function handleClick(e) {
        const _location = { lat: e.latLng.lat(), lng: e.latLng.lng() }
        setLocation(_location);
        console.log(_location);
    }

    const handlePost = () => {
        if (props.setLocation)
            props.setLocation(location);

        handleClose();
    }

    const { isLoaded, loadError } = useLoadScript({ googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY });
    if (!isLoaded) return <div>Loading...</div>

    return (
        <Modal
            size={width() == "mobile" ? "sm" : "lg"}
            show={true}
            onHide={handleClose}
            centered
            animation={false}
            backdrop="static"
        >
            <Modal.Body className="maxWidth750">
                <Mapa handleClick={handleClick} location={location} />
                <div></div>
            </Modal.Body>
            <Modal.Footer>
                {isLoaded &&
                    <>
                        <Button color="success" onClick={e => { handlePost(e, false) }} >
                            Gravar
                        </Button>
                    </>
                }
                <Button color="secondary" onClick={handleClose}>
                    Fechar
                </Button>
            </Modal.Footer>
        </Modal>
    )

}

function Mapa(props) {
    return (
        <>
            <GoogleMap
                zoom={10}
                center={props.location}
                mapContainerClassName="map-container"
                onClick={props.handleClick}
            >
                <Marker position={props.location} />
            </GoogleMap>
        </>
    );
}

export default Index;


